export default __webpack_public_path__ + "static/app-screen-2-33b6e6e6b89c7f05d1596ed5ead02076.png";